import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import * as Yup from "yup";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";

const EditInventory = ({
  editInventoryMutate,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    editInventoryMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      inventoryName: selectedData?.inventoryName || "",
      mobile: selectedData?.mobile || "",
      status: selectedData?.status || "",
      id: selectedData?.id || "",
      lockInPeriod: selectedData?.lockInPeriod || "",
      noticePeriod: selectedData?.noticePeriod || "",
      address: selectedData?.address || "",
      building: selectedData?.building || "",
      userId:selectedData?.userId || "",
    },
    validationSchema: Yup.object().shape({
      inventoryName: Yup.string().required("Inventory name is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Enter Valid number")
        .required("Mobile number is required"),
      status: Yup.number()
        .required("Select Status")
        .min(1, "Status can be active or inactive"),
      id: Yup.number().required("Id is required"),
      lockInPeriod: Yup.number()
        .required("Lock In Period is required"),
      noticePeriod: Yup.number()
        .required("Notice Period is required")  
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditUser}>
      {editEntryLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Inventory </Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="userId">User Id</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="userId"
                      id="userId"
                      // className="bg-gray-100"
                      disabled
                      autoComplete="off"
                      required
                      value={formik.values.userId}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.userId && formik.errors.userId ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.userId}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                <Label htmlFor="inventoryName">Inventory Name</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    fullWidth
                    name="inventoryName"
                    id="inventoryName"
                    autoComplete="off"
                    required
                    value={formik.values.inventoryName}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.inventoryName && formik.errors.inventoryName ? (
                    <p className="text-rose-600 text-sm ">
                      {formik.errors.inventoryName}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
              </CombineInputGroup>
              
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="mobile">Phone</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="mobile"
                      id="mobile"
                      className=""
                      // disabled
                      autoComplete="off"
                      required
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                      maxLength={10}
                    />
                    {formik.touched.mobile && formik.errors.mobile ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.mobile}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="status">Status</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="status"
                      id="status"
                      style={{ height: "40px" }}
                      required
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      displayEmpty
                      className="w-full pl-2"
                    >
                      <MenuItem value="1">Active</MenuItem>
                      <MenuItem value="2">Booked</MenuItem>
                      <MenuItem value="3">Leased</MenuItem>
                      <MenuItem value="4">Hold</MenuItem>
                      <MenuItem value="6">Unavailable</MenuItem>
                      <MenuItem value="7">Delete</MenuItem>
                    </Select>
                    {formik.touched.status && formik.errors.status ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.status}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="lockInPeriod">Lock-In Period *</Label>
                  <FieldWrapper fullWidth>
                    <Select
                      className="w-full pl-2"
                      id="lockInPeriod"
                      name="lockInPeriod"
                      value={formik.values.lockInPeriod}
                      onChange={formik.handleChange}
                      required
                      style={{ height: "40px" }}
                    >
                      {Array.from({ length: 11 }, (_, i) => i + 1).map(
                        (month) => (
                          <MenuItem key={month} value={month}>
                            {month} {month === 1 ? "Month" : "Months"}
                          </MenuItem>
                        ),
                      )}
                    </Select>
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="noticePeriod">Notice Period *</Label>
                  <FieldWrapper fullWidth>
                    <Select
                      className="w-full pl-2"
                      id="noticePeriod"
                      name="noticePeriod"
                      value={formik.values.noticePeriod}
                      required
                      style={{ height: "40px" }}
                      onChange={formik.handleChange}
                    >
                      {Array.from({ length: 6 }, (_, i) => i + 1).map(
                        (month) => (
                          <MenuItem key={month} value={month}>
                            {month} {month === 1 ? "Month" : "Months"}
                          </MenuItem>
                        ),
                      )}
                    </Select>
                  </FieldWrapper>
                </InputGroup>

                
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="address">Address</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      fullWidth
                      name="address"
                      id="address"
                      autoComplete="off"
                      required
                      value={formik.values.address}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <p className="text-rose-600 text-sm ">
                        {formik.errors.address}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
                
                <InputGroup>
                <Label htmlFor="building">Building</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    fullWidth
                    name="building"
                    id="building"
                    autoComplete="off"
                    required
                    value={formik.values.building}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.building && formik.errors.building ? (
                    <p className="text-rose-600 text-sm ">
                      {formik.errors.building}
                    </p>
                  ) : null}
                </FieldWrapper>
              </InputGroup>
              </CombineInputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditInventory;
